import './GeneratePDF.scss'
import PDFPage1 from "./pages/PDFPage1";
import PDFPage2 from "./pages/PDFPage2";
import ExternalPDFPage2 from './pages/external/ExternalPDFPage2';
import PDFPage3 from "./pages/PDFPage3";
import ExternalPDFPage3 from "./pages/external/ExternalPDFPage3";
// import PDFPage4 from "./pages/PDFPage4";
import PDFPage5 from './pages/PDFPage5';
import ExternalPDFPage5 from './pages/external/ExternalPDFPage5';
import PDFPage6 from './pages/PDFPage6';
import PDFPage7 from './pages/PDFPage7';
import PDFPage8 from './pages/PDFPage8';
import PDFPage9 from './pages/PDFPage9';
// import PDFPage10 from './pages/PDFPage10';
import { useEffect, useState } from 'react';
import CompanyInformationServices from 'services/services/CompanyInformationServices';
import LtvAnalysisServices from 'services/services/LtvAnalysisServices';
import HousingCompanyService from 'services/services/HousingCompanyService';
import PtsServices from 'services/services/PtsServices';
import FinancialAnalysisSerices from 'services/services/FinancialAnalysisSerices';
import { Spin } from 'antd';
import Cookies from 'universal-cookie';
import PDFPage6DisclamerEdit from "./pages/pdf-page-6/PDFPage6DisclamerEdit";
import { useSearchParams } from "react-router-dom";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import PDFPage10 from './pages/PDFPage10';

function GeneratePDF(props: any) {
    const cookies = new Cookies();
    const [customerDetails, setCustomerDetails] = useState<any>({});
    const [customerLoanData, setCustomerLoanData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [ltvDetails, setLtvDetails] = useState<any>({});
    const [shareholderData, setShareholderData] = useState<any>();
    const [ptsData, setPtsData] = useState<any>();
    const [lineChartData, setLineChartData] = useState<[]>([]);
    const [barChartData, setBarChartData] = useState<[]>([]);
    const [heirarchyData, setHeirarchyData] = useState<[]>([]);
    const [customerId, setCustomerId] = useState<number>(props?.id);
    const [currentYear, setCurrentYear] = useState<number>(new Date().getFullYear());
    const [ptsSummary, setPTSSummary] = useState<any>();
    const [ptsSummaryTwo, setPTSSummaryTwo] = useState<any>();
    const [ptsSummaryThree, setPTSSummaryThree] = useState<any>();
    const [ptsSummaryColor, setPTSSummaryColor] = useState<any>();
    const [hcinfo, setHcinfo] = useState<any>({});
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [searchParams, setSearchParams] = useSearchParams();
    const showbtn = searchParams.get("showbtn");
    const [loanPriority, setLoanPriority] = useState<any>(null);
    const [loanDataId, setLoanDataId] = useState<number>(props?.loan_id);

    useEffect(() => {
        if (props?.id) {
            setLoading(true)
            setCustomerId(props?.id)
            setCurrentYear(new Date().getFullYear())
            getCustomerDetails();
            initialRenderData();
            getAllShareholderData(props?.id)
            getPTSData();
            getLineChartDetails();
            getBarChartDetails();
            getTreeData();
            getCustomerSummaryData();
            getCustomerSummaryDataTwo();
            getCustomerSummaryDataThree();
            setLoading(false)
            setLoanDataId(props?.loan_id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function getCustomerDetails() {
        let object: any = {};
        object.customer_id = props?.id;
        object.is_summary = 1;
        setLoading(true);
        CompanyInformationServices
            .getCustomerData(object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    setCustomerDetails(response?.data?.customer_data)
                    setCustomerLoanData(response?.data?.loan_data)
                    setHcinfo(response?.data?.hcinfo)
                    if(response?.data?.customer_data?.loan_data_info && response?.data?.customer_data?.loan_data_info == 'external'){
                        setLoanPriority('13');
                    }
                    // if(response?.data?.loan_data){
                    //     response?.data?.loan_data.map((item:any) => {
                    //         if(item?.loan_id && item?.loan_id == loanDataId){
                    //             setLoanPriority(item?.loan_data_priority);
                    //         }
                    //     })
                    // }
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    }

    const initialRenderData = () => {
        let object: any = {};
        object.customer_id = props?.id;

        let ltvAnalysis = cookies.get("ltvAnalysis-"+props?.id);
        if(ltvAnalysis){
            let ltvAnalysis2:any = ltvAnalysis;
            if(typeof ltvAnalysis2 === 'object'){
                object = { ...object, ...ltvAnalysis2}
            }
        }

        setLoading(true)
        LtvAnalysisServices
        .getLtvSummaryData(object)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                const responseData = response?.data?.data;
                setLtvDetails(responseData)
            }
            setLoading(false);
        })
        .catch((err: any) => {
            console.log(err)
            setLoading(false);
        });
    }

    const getAllShareholderData = async (id: any) => {
        setLoading(true);
        let object: any = {};
        object.name = id;
        const getAllDataCall = HousingCompanyService.getshareholder(object)

        let objectOne: any = {};
        objectOne.name = id;
        const getAllShareholderCall = HousingCompanyService.getallshareholder(objectOne)

        let objectTwo: any = {};
        objectTwo.name = id;
        const getMoreThanOneApartmentCall = HousingCompanyService.getmorethanoneapartment(objectTwo)

        let objectThree: any = {};
        objectThree.name = id;
        objectThree.is_summary = true;
        const getCompanyShareholderCall = HousingCompanyService.getcompanyshareholder(objectThree)

        let objectFour: any = {};
        objectFour.name = id;
        const getMoreThanTenPercentCall = HousingCompanyService.getmorethantenpercent(objectFour)
        try {
            let getAllData, getAllShareholderData, getAllShareholderTotalData, getMoreThanOneApartmentData, getMoreThanOneApartmentTotalData, getCompanyShareholderData, getCompanyShareholderTotalData, getMoreThanTenPercentData, getMoreThanTenPercentTotalData;

            const [
                getAllDataRes, getAllShareholderRes, getMoreThanOneApartmentRes, getCompanyShareholderRes, getMoreThanTenPercentRes
            ] = await Promise.all([
                getAllDataCall,
                getAllShareholderCall,
                getMoreThanOneApartmentCall,
                getCompanyShareholderCall,
                getMoreThanTenPercentCall
            ]);

            setLoading(false);

            if (getAllDataRes) {
                getAllData = getAllDataRes?.data?.data;
            }

            if (getAllShareholderRes) {
                getAllShareholderData = getAllShareholderRes?.data?.data;
                getAllShareholderTotalData = getAllShareholderRes?.data?.total;
            }

            if (getMoreThanOneApartmentRes) {
                getMoreThanOneApartmentData = getMoreThanOneApartmentRes?.data?.data;
                getMoreThanOneApartmentTotalData = getMoreThanOneApartmentRes?.data?.total;
            }

            if (getCompanyShareholderRes) {
                getCompanyShareholderData = getCompanyShareholderRes?.data?.data;
                getCompanyShareholderTotalData = getCompanyShareholderRes?.data?.total;
            }

            if (getMoreThanTenPercentRes) {
                getMoreThanTenPercentData = getMoreThanTenPercentRes?.data?.data;
                getMoreThanTenPercentTotalData = getMoreThanTenPercentRes?.data?.total;
            }

            const dataObj = {
                getAllData,
                getAllShareholderData,
                getAllShareholderTotalData,
                getMoreThanOneApartmentData,
                getMoreThanOneApartmentTotalData,
                getCompanyShareholderData,
                getCompanyShareholderTotalData,
                getMoreThanTenPercentData,
                getMoreThanTenPercentTotalData
            }
            setShareholderData(dataObj);
        } catch (e) {
            console.log(e)
        }
    };

    const getPTSData = async () => {
        let object: any = {};
        object.customer_id = props?.id;
        object.is_summary = true;
        setLoading(true);
        PtsServices
            .getPtsData(object)
            .then((response: any) => {
                if (response?.status === 200) {
                    const responseData = response?.data;
                    setPtsData(responseData)
                }
                setLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
            });
    }

    function getLineChartDetails() {
        let object: any = {};
        object.customer_id = customerId;
        object.year = currentYear;
        setLoading(true);
        FinancialAnalysisSerices
            .getLineChartData(object)
            .then((response) => {
                if (response?.data?.code === 200) {
                    setLineChartData(response?.data?.data)
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err)
                setLoading(false);
            });
    }

    function getBarChartDetails() {
        let object: any = {};
        object.customer_id = customerId;
        object.year = currentYear;
        setLoading(true);
        FinancialAnalysisSerices
            .getBarChartData(object)
            .then((response) => {
                if (response?.data?.code === 200) {
                    setBarChartData(response?.data?.data)
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err)
                setLoading(false);
            });
    }

    function getTreeData() {
        let object: any = {};
        object.customer_id = customerId;
        object.year = currentYear;
        setLoading(true);
        FinancialAnalysisSerices
            .getTreeData(object)
            .then((response) => {
                if (response?.data?.code === 200) {
                    setHeirarchyData(response?.data?.data || [])
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err)
                setLoading(false);
            });
    }

    const getCustomerSummaryData = () => {
        let object: any = {};
        object.customer_id = props?.id;
        CompanyInformationServices
            .getCustomerSummaryData(object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    const responseData = response?.data?.data;
                    const color = response?.data?.color;
                    setPTSSummaryColor(color)

                    setPTSSummary(responseData)
                }
            })
            .catch((err: any) => {
                console.log(err)
            });
    }

    const getCustomerSummaryDataTwo = () => {
        let object: any = {};
        object.customer_id = props?.id;
        object.pts_status = "Käynnissä";
        CompanyInformationServices
            .getCustomerSummaryData(object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    const responseData = response?.data?.data;
                    setPTSSummaryTwo(responseData)
                }
            })
            .catch((err: any) => {
                console.log(err)
            });
    }

    const getCustomerSummaryDataThree = () => {
        let object: any = {};
        object.customer_id = props?.id;
        object.pts_status = "Valmis";
        CompanyInformationServices
            .getCustomerSummaryData(object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    const responseData = response?.data?.data;
                    setPTSSummaryThree(responseData)
                }
            })
            .catch((err: any) => {
                console.log(err)
            });
    }

    return (
        <>
            <Spin spinning={loading} >
                <PDFPage1 customerDetails={customerDetails} {...props} />
                {loanPriority && loanPriority == '13' ? <ExternalPDFPage2 {...props}/> : <PDFPage2 {...props}/> }
                {props?.isEditable ? <hr className={(showbtn === '0' ? ' d-none' : '') } /> : ""}

                {loanPriority && loanPriority == '13' 
                    ? <ExternalPDFPage3 customerDetails={customerDetails} hcinfo={hcinfo} {...props} ltvDetails={ltvDetails} customerLoanData={customerLoanData} />
                    : <PDFPage3 customerDetails={customerDetails} hcinfo={hcinfo} {...props} ltvDetails={ltvDetails} customerLoanData={customerLoanData} />
                }

                {props?.isEditable ? <hr className={(showbtn === '0' ? ' d-none' : '') } /> : ""}
                {/* <PDFPage4/> */}

                {loanPriority && loanPriority == '13' 
                    ? <ExternalPDFPage5 data={customerLoanData?.find((f: any) => f.loan_id === props?.loan_id)} ltvDetails={ltvDetails} ptsSummary={ptsSummary} ptsSummaryTwo={ptsSummaryTwo} ptsSummaryThree={ptsSummaryThree} ptsSummaryColor={ptsSummaryColor} {...props}/>
                    : <PDFPage5 data={customerLoanData?.find((f: any) => f.loan_id === props?.loan_id)} ltvDetails={ltvDetails} ptsSummary={ptsSummary} ptsSummaryTwo={ptsSummaryTwo} ptsSummaryThree={ptsSummaryThree} ptsSummaryColor={ptsSummaryColor} {...props}/>
                }

                {props?.isEditable ? <hr className={(showbtn === '0' ? ' d-none' : '') } /> : ""}
                <PDFPage6 {...props} ltvDetails={ltvDetails} loanPriority={loanPriority}/>
                {props?.isEditable ? <hr className={(showbtn === '0' ? ' d-none' : '') } /> : ""}

                
                <PDFPage6DisclamerEdit {...props} printBtn={props?.printBtn} disclaimer_one={customerLoanData?.find((f: any) => f.loan_id === props?.loan_id)?.disclaimer_one}/>
                {props?.isEditable ? <hr className={'m-0' + (showbtn === '0' ? ' d-none' : '')} /> : ""}
                
                {loanPriority && loanPriority == '13' 
                    ? ""
                    :   <>
                            <PDFPage7 {...props} lineChartData={lineChartData} barChartData={barChartData} heirarchyData={heirarchyData} /> 
                            {props?.isEditable && loanPriority != '13' ? <hr className={(showbtn === '0' ? ' d-none' : '') } /> : ""}
                        </> 

                }

                <PDFPage8 {...props} shareholderData={shareholderData} loanPriority={loanPriority} />
                {props?.isEditable ? <hr className={(showbtn === '0' ? ' d-none' : '') } /> : ""}

                {loanPriority && loanPriority == '13' 
                    ? ""
                    : <>
                        <PDFPage9 {...props} ptsData={ptsData} />
                        {props?.isEditable ? <hr /> : ""}
                    </>
                }

                {/* <PDFPage10 {...props} /> */}
            </Spin>
        </>
    );
}

export default GeneratePDF;